import { useModalApi } from 'BreetHooks';

import Analytics from './Analytics';
import type { IAnalyticsViewOnlyType } from './Analytics.helpers';

export const DialogAnalytics = () => {
	const { getModalProps } = useModalApi();

	const modalMetaData = getModalProps('analyticsModal')?.metadata as { viewOnly: IAnalyticsViewOnlyType } | undefined;

	if (!modalMetaData?.viewOnly) {
		console.error('Analytics modal missing viewOnly metadata');
		return null;
	}

	return (
		<Analytics
			viewOnly={modalMetaData.viewOnly}
			hideStats
			isModal
		/>
	);
};
